module.exports = __webpack_public_path__ + "img/office.c05debb8.svg";